import * as React from 'react';
import './DiamondRuler.css';


interface DiamondRulerProps {
    value: number;
    activeColor?: string;
}

export class DiamondRuler extends React.Component<DiamondRulerProps> {
    render() {
        const { value, activeColor } = this.props;

        let leftSide = false;
        let displayValue = value;
        if (value < 0) {
            leftSide = true;
            displayValue = -value;
        }

        // we're subtracting 1 from the inclination value because the bar to mark it is width 3
        // so we need to move it one back to the left so the center of it lines up with the inclination value
        let factor = displayValue - 1;

        if (factor < 0) { factor = 0; }

        // convert 0...100 into updated scale
        factor = this.convert(factor);

        factor /= 2.0;

        if (leftSide) {
            factor = 50.0 - factor;
        } else {
            factor = 50.0 + factor;
        }

        return (
            <div className="diamond-ruler">
                <div className="ruler-bar">
                    <div className="ruler-segment segment-1" />
                    <div className="ruler-segment segment-2" />
                    <div className="ruler-segment segment-3" />
                    <div className="ruler-segment segment-4" />
                    <div className="center-line" />
                    <div className="ruler-segment segment-5" />
                    <div className="ruler-segment segment-6" />
                    <div className="ruler-segment segment-7" />
                    <div className="ruler-segment segment-8" />
                </div>
                <div 
                    className={`diamond-indicator`} 
                    style={{ 
                        left: `${factor}%`, 
                        backgroundColor: activeColor ? activeColor : undefined 
                    }}
                >
                    <span className="value">{Math.round(displayValue)}</span>
                </div>
            </div>
        );
    }

    private convert(val: number) {
        var percent = 0.0;

        if (val === 0) {
            return 0;
        } else if (val > 0 && val <= 49) { // 0-25%
            percent = val / 49.0;
            return percent * 25.0;
        } else if (val >= 50 && val <= 69) { // 25-50%
            percent = (val - 50) / 20.0;
            return 25.0 + percent * 25.0;
        } else if (val >= 70 && val <= 89) { // 50-75%
            percent = (val - 70) / 20.0;
            return 50.0 + percent * 25.0;
        } else if (val >= 90 && val <= 100) { // 75-100%
            percent = (val - 90) / 10.0;
            return 75.0 + percent * 25.0;
        }

        return val;
    }
}



// WEBPACK FOOTER //
// ./src/components/charts/DiamondRuler.tsx